export default __webpack_public_path__ + "static/media/9.f476751c.png";